import React, { useState, useEffect } from "react";
import axios from "../../config/axiosClient";
import Config from "../../config/Config";
import { RESOLVE_LOCAL_AUTH_STATE } from "./AuthActions";

const API_BASE = Config().url;

export default function EmailVerificationBanner() {
  const [status, setStatus] = useState(null); // null | 'unverified' | 'verified'
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");


  const auth = RESOLVE_LOCAL_AUTH_STATE();
  const isAuthed = auth.is_authenticated === "true";

  useEffect(() => {
    if (!isAuthed) return;
    axios
      .get(`${API_BASE}api/v1/auth/email-status/`)
      .then((res) => {
        if (!res.data.verified) {
          setStatus("unverified");
          setEmail(res.data.email || "");
        } else {
          setStatus("verified");
        }
      })
      .catch(() => {});
  }, [isAuthed]);

  if (!isAuthed || status !== "unverified") return null;

  const handleResend = async () => {
    setSending(true);
    setMessage("");
    try {
      const res = await axios.post(`${API_BASE}api/v1/auth/resend-verification/`, {
        email: email,
      });
      setMessage(res.data.detail || "Verification email sent.");
    } catch (err) {
      setMessage(err.response?.data?.detail || "Failed to send. Try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      background: "#fef3c7",
      borderBottom: "1px solid #f59e0b",
      padding: "10px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      flexWrap: "wrap",
      fontSize: 14,
    }}>
      <span style={{ color: "#92400e", fontWeight: 600 }}>
        Your email is not verified.
      </span>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        style={{
          padding: "4px 10px",
          border: "1px solid #d97706",
          borderRadius: 4,
          fontSize: 13,
          width: 220,
          background: "#fff",
        }}
      />
      <button
        onClick={handleResend}
        disabled={sending || !email.trim()}
        style={{
          padding: "4px 16px",
          border: "none",
          borderRadius: 4,
          background: "#d97706",
          color: "#fff",
          fontSize: 13,
          fontWeight: 600,
          cursor: sending ? "not-allowed" : "pointer",
          opacity: sending ? 0.6 : 1,
        }}
      >
        {sending ? "Sending..." : "Send Verification Email"}
      </button>
      {message && (
        <span style={{ color: "#92400e", fontSize: 13 }}>{message}</span>
      )}
    </div>
  );
}
